import { retrieve } from '@exonet/jsonapi-fetcher/lib/resources';

// Contracts.
import { getDomainHandle } from 'app/client/modules/Domains/contracts';

export default {
  /**
   * Get action on mount.
   *
   * @param {Object} store The store instance containing the state and dispatch.
   * @param {string} invoiceId The ID to fetch.
   *
   * @return {Promise} A promise to fetch data.
   */
  onMount: (store, { handleId = null }) => {
    if (handleId === null || (Array.isArray(handleId) && handleId.length === 0)) {
      return Promise.resolve();
    }

    return retrieve(getDomainHandle(handleId), store).get();
  },
};
